module.exports = __webpack_public_path__ + "img/pavl3.6f9af266.jpg";